import {NavigationTabsModuleTabModel} from "./navigation-tabs-module.tab-model";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {override} from "mobx";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";
import {COMPETITION_CONTAINER} from "../../../../containers/competition-container/competition-container.consts";

export class MatchesTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: EntityViewModel;
  currentLinkModel: BaseLinkModel;
  isWidget: boolean;

  constructor(
    index: Number,
    name: String,
    entity: EntityViewModel,
    currentLinkModel: BaseLinkModel,
    isWidget: boolean
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
    this.isWidget = isWidget;
  }

  @override get isVisible(): Boolean {
    return this.entity;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.filter === COMPETITION_CONTAINER.FILTERS.matches;
  }

  get eventName(): String {
    return ACTION_TYPES.matchesClick;
  }

  get eventParams(): Object {
    const eventParams = {
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[this.entity.objectType],
      entityId: this.entity.id,
      source: APP.ANALYTICS.SOURCES[this.entity.name],
      sportTypeId: this.entity.sport.id
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.matches;
  }

  get elementId(): String {
    return 'navigation-tabs_matches';
  }
}






